import React, {useEffect, useState, useRef} from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import ResponseMsg2 from '../general/ResponseMsg2';
import { Bs1CircleFill, Bs2CircleFill, Bs3CircleFill, Bs4CircleFill, Bs5CircleFill } from 'react-icons/bs';
import { FaCheck, FaEye, FaEyeSlash } from 'react-icons/fa';

const Register = ({setLoading}) => {
            const [response2, setResponse2] = useState({ message: '', status: 'success' });
            const [lastReg, setLastReg] = useState([]);
             const [classes, setClasses] = useState([]);
               const [selectedClassId, setSelectedClassId] = useState('');
            const [formData, setFormData] = useState({
              ay: new Date().getFullYear(),
                name: '',
                reg_no: '',
                admission_no: '',
                roll_no: '',
                pen_no: '',
                apaar_no: '',
                dob: '',
                dor_reg: new Date().toISOString().split('T')[0],
                doa: '',
                class_id: '',
                section: '',
        gender: '',
        religion: '',
        nationality: '',
        father: '',
        f_occupation: '',
        f_mobile: '',
        f_qualification: '',
        f_email: '',
        mother: '',
        m_occupation: '',
        m_mobile: '', 
        m_qualification: '',
        m_email: '',
        address: '',
        blood_grp: '',
        mobile: '',
        email: '',
        pass: '',
        old_school_detail: '',
        category: '',
        m_tongue: '',
        siblings: [],
        single_girl_child: 'No',
        specially_abled: 'No',
        aadhaar_no: '',
        tc_no: '',
        tc_issue_date: '',
        fee_discount: '',
        // bank_name: '',
        // ifsc_code: '',
        // acc_holder: '',
        // acc_no: '',
        aadhaar_pic: null,
        profile_pic: null,
            });
        
            //  const [selectedFiles, setSelectedFiles] = useState([]);
    
        
    const handleChange = (e) => {
      const { name, value, files } = e.target;
    
      setFormData((prev) => {
        const updatedForm = {
          ...prev,
          [name]: files ? files[0] : value,
        };
    
        if (name === 'mobile' && value.length === 10) {
          updatedForm.pass = value;
        }
    
        return updatedForm;
      });
    };
    
    
useEffect(() => {
  if (lastReg) {
    const lastRegStr = String(lastReg);
    const match = lastRegStr.match(/(\d+)$/);

    console.log(lastRegStr, match);

    if (match && match[1]) {
      const number = parseInt(match[1], 10); 
      const incremented = number + 1;

      const prefix = lastRegStr.slice(0, -match[1].length);
      const paddedNumber = String(incremented).padStart(match[1].length, "0");

      setFormData(prev => ({
        ...prev,
        reg_no: prefix + paddedNumber
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        reg_no: lastRegStr + "1"
      }));
    }
  }
}, [lastReg]);


    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          const submitData = new FormData();
     const selectedClass = classes.find(cls => cls.id === Number(selectedClassId));
        const className = selectedClass ? selectedClass.class_name : '';
    
    
        for (const key in formData) {
  if (key === 'profile_pic' && formData.profile_pic) {
    submitData.append(key, formData.profile_pic);
  } else if (key === 'aadhaar_pic' && formData.aadhaar_pic) {
    submitData.append(key, formData.aadhaar_pic);
  } else if (key === 'class_id') {
    submitData.append('class_name', className);
  } else if (key === 'siblings') {
        submitData.append('siblings', JSON.stringify(formData.siblings));
  } else {
    submitData.append(key, formData[key]);
  }
}

    
          const response = await fetch('https://api.kcian.in/add-student', {
            method: 'POST',
            body: submitData,
          });
    
          const data = await response.json();
    
          if (response.ok) {
            setResponse2({ message: 'Student Registration Successful!', status: 'success' });
            fetchLastReg();
    
            setFormData({
              ay: new Date().getFullYear(),
                name: '',
                reg_no: '',
                admission_no: '',
                roll_no: '',
                pen_no: '',
                apaar_no: '',
                dob: '',
                dor_reg: '',
                doa: '',
                class_id: '',
                section: '',
        gender: '',
        religion: '',
        nationality: '',
        father: '',
        f_occupation: '',
        f_mobile: '',
        f_qualification: '',
        f_email: '',
        mother: '',
        m_occupation: '',
        m_mobile: '', 
        m_qualification: '',
        m_email: '',
        address: '',
        blood_grp: '',
        mobile: '',
        email: '',
        pass: '',
        old_school_detail: '',
        category: '',
        m_tongue: '',
        siblings: [],
        single_girl_child: 'No',
        specially_abled: 'No',
        aadhaar_no: '',
        tc_no: '',
        tc_issue_date: '',
        fee_discount: '',
        // bank_name: '',
        // ifsc_code: '',
        // acc_holder: '',
        // acc_no: '',
        aadhaar_pic: null,
        profile_pic: null,
            });
            setSelectedClassId('');
    
            setTimeout(() => {
              setResponse2('');
            }, 2000);   
          } else {
            setResponse2({ message: data.message || 'Something went wrong. Please try again later.', status: 'error' });
            setTimeout(() => {
              setResponse2('');
            }, 2000);   
          }
        } catch (error) {
          console.error('Error submitting form:', error);
        }
      };
    
        const fetchLastReg = async () => {
                              setLoading(true);
                      try {
                          const response = await fetch('https://api.kcian.in/get-last-regno');
         
                          if (response.ok) {
                              const data = await response.json();
                              console.log(data);
                              setLastReg(data.reg_no);
                              setLoading(false);
                          } else {
                              setLoading(false);
                              setLastReg(null);
                          }
                      } catch (error) {
                          setLoading(false);
                          console.error('Error fetching data:', error);
                      }
        }
    
    
             const fetchClasses = async () => {
                               setLoading(true);
                       try {
                           const response = await fetch('https://api.kcian.in/get-classes');
           
                           if (response.ok) {
                               const data = await response.json();
                               setClasses(data);
                               setLoading(false);
                                                         console.log(data);
    
                           } else {
                               setLoading(false);
                               console.error('Failed to fetch class');
                           }
                       } catch (error) {
                           setLoading(false);
                           console.error('Error fetching data:', error);
                       }
         }
    
    

      useEffect(() => {
        fetchLastReg();
        fetchClasses();
      }, [])
    
      
      useEffect(() => {
      setFormData((prev) => ({
        ...prev,
        class_id: selectedClassId,
      }));
    }, [selectedClassId]);
    
    // useEffect(() => {
    //   setFormData((prev) => ({
    //     ...prev,
    //     section: selectedSection,
    //   }));
    // }, [selectedSection]);
    

  return (
    <>
          <ScrollAnimation animateIn='fadeInUp'>
      <div className='safely-measures1'>
      <h2 >REGISTRATION FORM</h2>
        <p>"We strive to equip learners with the knowledge, skills, and values they need to succeed and thrive in a rapidly changing world.<br />
        Please fill out the registration form below to begin the admission process."</p>
       
      </div>
      </ScrollAnimation>

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<section className='py-5'>
    <div className='container'>
  <form onSubmit={handleSubmit}>
<div className='row'>

    <p className='fw-semibold border-bottom mb-5'><Bs1CircleFill /> Basic Information</p>


            {/* Name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Full Name*</label>
                <input type='text' name='name' value={formData.name} onChange={handleChange} className='profile-input' required />
              </div>
            </div>



           {/* Mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mobile Number*</label>
                <input type='tel' name='mobile' value={formData.mobile} maxLength={10} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

{/* Date of Birth */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Birth*</label>
                <input type='date' name='dob' value={formData.dob} onChange={handleChange} className='profile-input' required />
              </div>
            </div>



                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
                    <select
                      className="profile-input"
                      value={selectedClassId}
                      onChange={(e) => setSelectedClassId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
</div>
                  </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Category*</label>
                <select name='category' value={formData.category} onChange={handleChange} className='profile-input' required>
                  <option value=''>Select Category</option>
                  <option value='General'>General</option>
                  <option value='EWS'>EWS</option>
                  <option value='OBC'>OBC</option>
                  <option value='SC'>SC</option>
                  <option value='ST'>ST</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Pen no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Apaar Id</label>
                <input type='text' name='apaar_no' value={formData.apaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


    <p className='fw-semibold border-bottom mb-5'><Bs2CircleFill /> Aadhaar Details</p>


{/* Aadhar no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar No</label>
                <input type='text' name='aadhaar_no' value={formData.aadhaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar Pdf</label>
                <input type='file' name='aadhaar_pic' accept='application/pdf' onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <p className='para-text fw-bold mb-4'>Whether the candidate is: -</p>


{/* Single Girl Child */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area border-0'>
    <label className='profile-badge'>Single Girl Child?</label>
    <div className="d-flex gap-3 mt-3">
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.single_girl_child === 'Yes' ? 'btn-success' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, single_girl_child: 'Yes' }))}
      >
        Yes
      </button>
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.single_girl_child === 'No' || !formData.single_girl_child ? 'btn-danger' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, single_girl_child: 'No' }))}
      >
        No
      </button>
    </div>
  </div>
</div>

{/* Specially Abled */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area border-0'>
    <label className='profile-badge'>Specially abled?</label>
    <div className="d-flex gap-3 mt-3">
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.specially_abled === 'Yes' ? 'btn-success' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, specially_abled: 'Yes' }))}
      >
        Yes
      </button>
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.specially_abled === 'No' || !formData.specially_abled ? 'btn-danger' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, specially_abled: 'No' }))}
      >
        No
      </button>
    </div>
  </div>
</div>



    <p className='fw-semibold border-bottom mb-5'><Bs3CircleFill /> Other Information</p>

            {/* Profile Picture */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Profile Picture</label>
                <input type='file' name='profile_pic' onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Blood Group */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Blood Group</label>
                <input type='text' name='blood_grp' value={formData.blood_grp} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* User ID */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Email Address</label>
                <input type='email' name='email' value={formData.email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Gender */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Gender*</label>
                <select name='gender' value={formData.gender} onChange={handleChange} className='profile-input' required>
                  <option value=''>Select Gender</option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Religion */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Religion</label>
                <select name='religion' value={formData.religion} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Religion</option>
                  <option value='Hinduism'>Hinduism</option>
                  <option value='Muslim'>Muslim</option>
                  <option value='Non Muslim'>Non Muslim</option>
                  <option value='Christianity'>Christianity</option>
                  <option value='Islam'>Islam</option>
                  <option value='Jainism'>Jainism</option>
                  <option value='Buddhism'>Buddhism</option>
                   <option value='Sikhism'>Sikhism</option>
                  <option value='Non Religious'>Non Religious</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Nationality */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Nationality</label>
                <input type='text' name='nationality' value={formData.nationality} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* mother tongue */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother Tongue</label>
                <input type='text' name='m_tongue' value={formData.m_tongue} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* TC No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>TC (Transfer Certificate) No</label>
                <input type='text' name='tc_no' value={formData.tc_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* TC Date */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>TC Issue Date</label>
                <input type='date' name='tc_issue_date' value={formData.tc_issue_date} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Address */}
            <div className='mb-4 mt-2 col-md-6 col-12'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Address*</label>
                <textarea name='address' value={formData.address} onChange={handleChange} className='profile-input' rows='3' required />
              </div>
            </div>

            {/* Old School */}
            <div className='mb-4 mt-2 col-md-6 col-12'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Old School Detail</label>
                <textarea name='old_school_detail' value={formData.old_school_detail} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>



                <p className='fw-semibold border-bottom mb-5'><Bs4CircleFill /> Guardian Details</p>

{/* Father name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father Name</label>
                <input type='text' name='father' value={formData.father} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* occupation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Occupation</label>
                <input type='text' name='f_occupation' value={formData.f_occupation} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Mobile No</label>
                <input type='tel' name='f_mobile' value={formData.f_mobile} maxLength={10} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Email</label>
                <input type='text' name='f_email' value={formData.f_email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* qualification */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Qualification</label>
                <input type='text' name='f_qualification' value={formData.f_qualification} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <div className='mb-4 col-md-4'>
</div>

{/* Mother name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother Name</label>
                <input type='text' name='mother' value={formData.mother} onChange={handleChange} className='profile-input' />
              </div>
            </div>


{/* occupation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Occupation</label>
                <input type='text' name='m_occupation' value={formData.m_occupation} onChange={handleChange} className='profile-input' />
              </div>
            </div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Mobile No</label>
                <input type='tel' name='m_mobile' value={formData.m_mobile} maxLength={10} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Email</label>
                <input type='text' name='m_email' value={formData.m_email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* qualification */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Qualification</label>
                <input type='text' name='m_qualification' value={formData.m_qualification} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <div className='mb-4 col-md-4'>
</div>



                <p className='fw-semibold border-bottom mb-5'><Bs5CircleFill /> Siblings Details (if Any)</p>

<div className='col-12'>
  {formData.siblings.length > 0 &&
    formData.siblings.map((sibling, index) => (
      <div key={index} className='row align-items-end mb-4'>
        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Name</label>
            <input
              type='text'
              className='profile-input'
              value={sibling.name}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].name = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Relation</label>
            <select
              className='profile-input'
              value={sibling.relation}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].relation = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            >
              <option value=''>Select</option>
              <option value='Brother'>Brother</option>
              <option value='Sister'>Sister</option>
            </select>
          </div>
        </div>

        <div className='col-md-2'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Age</label>
            <input
              type='number'
              className='profile-input'
              value={sibling.age}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].age = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>School Studying</label>
            <input
              type='text'
              className='profile-input'
              value={sibling.school_studying}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].school_studying = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-1 text-end'>
          <button
            type='button'
            className='btn btn-danger rounded-circle'
            onClick={() => {
              const updated = [...formData.siblings];
              updated.splice(index, 1);
              setFormData({ ...formData, siblings: updated });
            }}
          >
            −
          </button>
        </div>
      </div>
    ))}

  <button
    type='button'
    className='profile-btn2 float-end'
    onClick={() =>
      setFormData({
        ...formData,
        siblings: [
          ...formData.siblings,
          { name: '', relation: '', age: '', school_studying: '' }
        ]
      })
    }
  >
    + Add Sibling
  </button>
</div>



<div className='px-2'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}</div>

 <div className='col-12 mt-4'>
                <button type='submit' className='profile-btn'><FaCheck /> Submit</button>
              </div>


</div>
</form>
{/* row ends */}
</div>
</section>



    </>
  )
}

export default Register